import { setHoveredElementKey } from "@/store/iframeSlice";
import _ from "lodash";
import { useRef } from "react";
import { useDispatch } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { TempoElement } from "./tempoElement";
import { useIframeStore } from "@/store/zustand/iframeStore";

export const useThrottledSetHoveredElement = () => {
  const dispatch = useDispatch();

  return useRef(
    _.throttle(
      (element?: TempoElement) => {
        if (element) {
          dispatch(setHoveredElementKey(element.getKey()));
        } else {
          dispatch(setHoveredElementKey(null));
        }
      },
      50,
      {
        leading: true,
        trailing: false,
      }
    )
  );
};

export const useThrottledSendSyntheticMouseOverEvent = () => {
  return useRef(
    _.throttle(
      (storyboardId: string, pointX: number, pointY: number, cType: string) => {
        useIframeStore.getState().sendMessageToIFrame(
          {
            type: "executeFunction",
            id: uuidv4(),
            payload: {
              functionName: "syntheticMouseOver",
              args: [
                {
                  x: pointX,
                  y: pointY,
                },
                true,
                true,
              ],
            },
          },
          storyboardId
        );
      },
      50,
      {
        leading: true,
        trailing: false,
      }
    )
  );
};

export const useThrottledSyntheticMouseMove = () => {
  return useRef(
    _.throttle(
      (
        storyboardId: string,
        clientX: number,
        clientY: number,
        buttons?: number
      ) => {
        useIframeStore.getState().sendMessageToIFrame(
          {
            type: "executeFunction",
            id: uuidv4(),
            payload: {
              functionName: "syntheticMouseMove",
              args: [
                {
                  clientX,
                  clientY,
                  buttons,
                },
              ],
            },
          },
          storyboardId
        );
      },
      50,
      {
        leading: true,
        trailing: false,
      }
    )
  );
};

export const sendSyntheticMouseUp = (storyboardId: string) => {
  // Directly post this message to make this whole process faster
  useIframeStore.getState().sendMessageToIFrame(
    {
      type: "executeFunction",
      id: uuidv4(),
      payload: {
        functionName: "syntheticMouseUp",
        args: [{}],
      },
    },
    storyboardId
  );
};

export const useSendDrawingDiv = () => {
  return useRef(
    _.throttle(
      (
        storyboardId: string,
        codebaseIdToAddTo: string,
        indexInParent: number,
        width: number,
        height: number
      ) => {
        // Send the drawing div to get created, or to be resized
        useIframeStore.getState().sendMessageToIFrame(
          {
            type: "executeFunction",
            id: uuidv4(),
            payload: {
              functionName: "tempAddDiv",
              args: [codebaseIdToAddTo, indexInParent, width, height],
            },
          },
          storyboardId
        );
      },
      25,
      {
        leading: true,
        trailing: false,
      }
    )
  );
};

export const getTreeElementLookupToSend = (treeElementLookup: any): any => {
  const treeElementToSend = {};

  Object.keys(treeElementLookup).forEach((codebaseId: any) => {
    const element = treeElementLookup[codebaseId];

    if (!element) {
      treeElementToSend[codebaseId] = null;
      return;
    }

    if (!element) {
      return;
    }

    // Currently the only fields used in the iframe
    treeElementToSend[element.codebaseId] = {
      type: element.type,
      componentName: element.componentName,
      filename: element.filename,
      removableClasses: element.removableClasses,
      staticTextContents: element.staticTextContents,
    };
  });

  return treeElementToSend;
};
